import React from 'react'
import { UIVars } from '~ui'

const getPath = (name: string, props: any) => {
  const lock = (
    <path
      {...props}
      d="M7,0 C4.8,0 3,1.8 3,4 L3,5 L1,5 C0.4,5 0,5.4 0,6 L0,15 C0,15.6 0.4,16 1,16 L13,16 C13.6,16 14,15.6 14,15 L14,6 C14,5.4 13.6,5 13,5 L11,5 L11,4 C11,1.8 9.2,0 7,0 Z M8,11.7 L8,13 L6,13 L6,11.7 C5.4,11.4 5,10.7 5,10 C5,8.9 5.9,8 7,8 C8.1,8 9,8.9 9,10 C9,10.7 8.6,11.4 8,11.7 Z M9,5 L5,5 L5,4 C5,2.9 5.9,2 7,2 C8.1,2 9,2.9 9,4 L9,5 Z"
    />
  )
  const lockWithHole = (
    <path
      {...props}
      d="M6.5 0C4.457 0 2.786 1.671 2.786 3.714v.929H.929C.37 4.643 0 5.014 0 5.57v8.358c0 .557.371.928.929.928H12.07c.558 0 .929-.371.929-.928V5.57c0-.557-.371-.928-.929-.928h-1.857v-.929C10.214 1.671 8.543 0 6.5 0zm.929 10.864v1.207H5.57v-1.207c-.557-.278-.928-.928-.928-1.578 0-1.022.836-1.857 1.857-1.857s1.857.835 1.857 1.857c0 .65-.371 1.3-.928 1.578zm.928-6.221H4.643v-.929c0-1.021.836-1.857 1.857-1.857s1.857.836 1.857 1.857v.929z"
    />
  )
  const trashNoX = (
    <g {...props} fillRule="nonzero">
      <path
        d="M13.9595376,4 L13.9595376,2 L9.59718208,2 L9.59718208,1 C9.59718208,0.44771525 9.20656346,0 8.72471098,0 L5.23482659,0 C4.75297411,0 4.36235549,0.44771525 4.36235549,1 L4.36235549,2 L0,2 L0,4 L13.9595376,4 Z"
        id="Path"></path>
      <path
        d="M1.7449422,5 L1.7449422,14 C1.7449422,15.1045695 2.52617943,16 3.48988439,16 L10.4696532,16 C11.4333581,16 12.2145954,15.1045695 12.2145954,14 L12.2145954,5 L1.7449422,5 Z"
        id="Shape"></path>
    </g>
  )
  const tiltedPen = (
    <path
      {...props}
      d="M8.1 3.5L.3 11.3c-.2.2-.3.4-.3.7v3c0 .6.4 1 1 1h3c.3 0 .5-.1.7-.3l7.8-7.8-4.4-4.4zM15.7 3.3l-3-3c-.4-.4-1-.4-1.4 0L9.5 2.1l4.4 4.4 1.8-1.8c.4-.4.4-1 0-1.4z"
    />
  )
  const add = (
    <path
      {...props}
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H9v3H7V9H4V7h3V4h2v3h3v2z"
    />
  )
  const portafolio = (
    <path
      {...props}
      d="M13,5 L11,5 L11,4 C11,1.8 9.2,0 7,0 C4.8,0 3,1.8 3,4 L3,5 L1,5 C0.4,5 0,5.4 0,6 L0,15 C0,15.6 0.4,16 1,16 L13,16 C13.6,16 14,15.6 14,15 L14,6 C14,5.4 13.6,5 13,5 Z M5,4 C5,2.9 5.9,2 7,2 C8.1,2 9,2.9 9,4 L9,5 L5,5 L5,4 Z"
    />
  )
  const justCheck = (
    <path
      {...props}
      d="M7.125 10.531l5.385-5.385 1.097 1.097-6.364 6.364L3 8.364l.98-.98z"
      fill="#0189FF"
    />
  )

  const filterNewOld = (
    <path
      {...props}
      d="M8.64286 12.175V6.33333H7.07143V12.175H4.71429L7.85714 15.5L11 12.175H8.64286ZM3.14286 0.5L0 3.825H2.35714V9.66667H3.92857V3.825H6.28571L3.14286 0.5Z"
      fill="#0189FF"
    />
  )

  const profileIcon = (
    <path
      {...props}
      d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M12.1,12.3c-0.4-0.7-1.2-1-2.1-1.3
	  c-0.7-0.2-0.9-0.6-1-1.2c1.1-0.4,2-1.5,2-2.8c0-1.7-1.3-3-3-3S5,5.3,5,7c0,1.3,0.8,2.4,2,2.8c-0.1,0.6-0.3,1-1,1.2
	  c-0.9,0.3-1.7,0.6-2.1,1.3C2.7,11.2,2,9.7,2,8c0-3.3,2.7-6,6-6s6,2.7,6,6C14,9.7,13.3,11.2,12.1,12.3z"
    />
  )
  const bell = (
    <path
      {...props}
      d="M11.826 6.957V4.87A4.84 4.84 0 0 0 6.956 0a4.84 4.84 0 0 0-4.869 4.87v2.087C2.087 9.252 0 9.809 0 11.13c0 1.183 2.713 2.087 6.957 2.087 4.243 0 6.956-.904 6.956-2.087 0-1.321-2.087-1.878-2.087-4.173zm-4.869 7.652c-.905 0-1.67-.07-2.435-.14C5.009 15.375 5.913 16 6.957 16 8 16 8.974 15.374 9.39 14.47c-.765.07-1.53.139-2.434.139z"
    />
  )

  const comment = (
    <path
      {...props}
      d="M8 0C3.6 0 0 3.1 0 7s3.6 7 8 7c.4 0 .8 0 1.1-.1L14 16v-4.4c1.2-1.2 2-2.8 2-4.6 0-3.9-3.6-7-8-7z"
    />
  )
  const flag = (
    <path
      {...props}
      fillRule="evenodd"
      d="M12 6l2-5H2c0-.6-.4-1-1-1S0 .4 0 1v14c0 .6.4 1 1 1s1-.4 1-1v-4h12l-2-5z"
    />
  )

  const circleCheck = (
    <path
      {...props}
      d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M7,11.4L3.6,8L5,6.6l2,2l4-4L12.4,6L7,11.4z"></path>
  )

  const belongs = (
    <path
      {...props}
      fillRule="evenodd"
      d="M11 0H8v7L5.5 5 3 7V0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h10c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3z"
    />
  )
  const certificate = (
    <g {...props} fillRule="nonzero">
      <path d="M7 4h2v2H7z" />
      <path d="M15 8h-2V4.618l.553.277a1 1 0 1 0 .894-1.79l-6-3a1 1 0 0 0-.894 0l-6 3a1 1 0 0 0 .894 1.79L3 4.618V8H1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6v-4h2v4h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM5 13H3v-3h2v3zm0-5V4a.98.98 0 0 0-.07-.347L8 2.118l3.07 1.535A.98.98 0 0 0 11 4v4H5zm8 5h-2v-3h2v3z" />
    </g>
  )
  const alert = (
    <path
      {...props}
      fillRule="nonzero"
      d="M8 .278c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7v-5h2v5z"
    />
  )
  const calendar = (
    <g {...props} fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 12H2V5h12v9z"
      />
      <path d="M4 7h2v2H4zM7 7h2v2H7zM4 10h2v2H4zM7 10h2v2H7zM10 7h2v2h-2zM10 10h2v2h-2z" />
    </g>
  )
  const calendarTime = (
    <g {...props} fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M15 2h-2V0h-2v2H9V0H7v2H5V0H3v2H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 12H2V5h12v9z"
      />
      <path d="M11 11H7V7h2v2h2z" />
    </g>
  )
  const informationWelcome = (
    <g fill="none" fillRule="evenodd">
      <g transform="translate(1 1)">
        <circle cx={13} cy={13} r={13} {...props} />
        <path
          fill="#FFF"
          d="M10 10.75h4.314v7.07h1.336v2.541H10V17.82h1.447v-4.527H10V10.75zm1.299-3.099c0-.228.042-.443.125-.644a1.602 1.602 0 0 1 .872-.877c.201-.087.42-.13.654-.13.223 0 .433.043.631.13a1.664 1.664 0 0 1 1.002 1.521 1.664 1.664 0 0 1-1.002 1.521c-.198.087-.408.13-.63.13a1.635 1.635 0 0 1-1.179-.482 1.602 1.602 0 0 1-.348-.524 1.664 1.664 0 0 1-.125-.645z"
        />
      </g>
      <path
        {...props}
        fillRule="nonzero"
        d="M14 28C6.268 28 0 21.732 0 14S6.268 0 14 0s14 6.268 14 14-6.268 14-14 14zm0-2c6.627 0 12-5.373 12-12S20.627 2 14 2 2 7.373 2 14s5.373 12 12 12z"
      />
    </g>
  )
  const informationGmt = (
    <path
      {...props}
      fillRule="nonzero"
      d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm2.658 18.284c-.661.26-2.952 1.354-4.272.191a1.676 1.676 0 0 1-.59-1.318c0-.998.328-1.868.919-3.957.104-.395.231-.907.231-1.313 0-.701-.266-.887-.987-.887-.352 0-.742.125-1.095.257l.195-.799c.787-.32 1.775-.71 2.621-.71 1.269 0 2.203.633 2.203 1.837 0 .347-.06.955-.186 1.375l-.73 2.582c-.151.522-.424 1.673-.001 2.014.416.337 1.401.158 1.887-.071l-.195.799zM13.452 8a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 13.452 8z"
    />
  )
  const letter = (
    <g {...props} fillRule="evenodd">
      <path d="M15 2H1c-.6 0-1 .4-1 1v1.4l8 4.5 8-4.4V3c0-.6-.4-1-1-1z" />
      <path d="M7.5 10.9L0 6.7V15c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V6.7l-7.5 4.2c-.28.14-.72.14-1 0z" />
    </g>
  )
  const phone = (
    <path
      {...props}
      d="M15.086 10.4l-3.137-1.392c-.31-.137-.657-.168-.987-.088-.33.08-.624.266-.837.53l-.947 1.185c-1.535-.976-2.836-2.278-3.813-3.812l1.184-.946c.265-.213.452-.507.533-.837.08-.33.049-.678-.089-.989L5.6.914C5.452.581 5.19.311 4.862.153 4.534-.006 4.16-.043 3.807.049L1.155.738c-.366.096-.684.322-.894.636-.21.315-.298.695-.246 1.07.491 3.417 2.076 6.583 4.517 9.024 2.441 2.441 5.608 4.026 9.025 4.517.07.01.141.015.212.015.341 0 .673-.114.943-.322.27-.21.464-.502.55-.832l.688-2.653c.093-.353.057-.727-.101-1.056-.159-.328-.43-.59-.763-.737z"
    />
  )
  const arrow = (
    <path
      {...props}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 4l4.5 4.5L6 13"
    />
  )
  const arrowBack = (
    <path
      {...props}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.5 12L5 7.5 9.5 3"
    />
  )
  const arrowBig = (
    <path
      {...props}
      fillRule="evenodd"
      d="M8.106 12.235a.934.934 0 0 1-.611-.227L.212 5.75l1.222-1.43 6.672 5.735 6.672-5.735L16 5.75l-7.283 6.258a.934.934 0 0 1-.611.227z"
    />
  )
  const arrowDown = (
    <path
      {...props}
      fillRule="evenodd"
      d="M8 11.4L2.6 6 4 4.6l4 4 4-4L13.4 6z"
    />
  )
  const close = (
    <path
      {...props}
      fillRule="nonzero"
      d="M10.678.334a1.099 1.099 0 0 0-1.553 0L5.507 3.952 1.889.334A1.099 1.099 0 0 0 .335 1.887l3.618 3.618L.335 9.123a1.099 1.099 0 1 0 1.554 1.554l3.618-3.618 3.618 3.618a1.099 1.099 0 0 0 1.553-1.554L7.06 5.505l3.618-3.618a1.099 1.099 0 0 0 0-1.553z"
    />
  )

  const inProgress = (
    <path
      {...props}
      fillRule="evenodd"
      d="M5 1h6.792a1 1 0 0 1 .751 1.66L10.49 5l2.044 2.308a1 1 0 0 1-.745 1.663L5 8.993V14c0 .667-.336 1-1.008 1-.672 0-1.002-.333-.992-1V2a1 1 0 0 1 1-1h1z"
    />
  )

  const opened = (
    <path
      {...props}
      fillRule="nonzero"
      d="M10.005 7V4.1c0-.71-.581-1.35-1.605-1.35S7.005 3.29 7.005 4c0 .67-.333 1.005-.998 1.005-.666 0-1-.335-1-1.004C5.007 2.253 6.442 1 8.4 1 10.358 1 12 2.353 12 4.1V7a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6.005z"
    />
  )

  const blocked = (
    <path
      {...props}
      fillRule="nonzero"
      d="M6 7h4.018V4.1c0-.71-.555-1.35-2.018-1.35-1.463 0-2 .64-2 1.35V7zm6.02 0A1 1 0 0 1 13 8v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 .992-1V4.1C3.992 2.354 6.042 1 8 1c1.958 0 4.02 1.353 4.02 3.1V7z"
    />
  )
  const blockedIsTest = (
    <g {...props}>
      <path
        fillRule="nonzero"
        d="M3.5 7h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1z"
      />
      <path d="M2.5 4h11v2h-11z" />
      <path d="M5.5 2a1 1 0 0 1 1 1v2h-2V3a1 1 0 0 1 1-1zM10.5 2a1 1 0 0 1 1 1v2h-2V3a1 1 0 0 1 1-1z" />
    </g>
  )

  const completed = (
    <path
      {...props}
      fillRule="nonzero"
      d="M13.173 3.325L6.34 10.327 3.852 7.775a1.067 1.067 0 0 0-1.522.014 1.133 1.133 0 0 0-.013 1.56l3.257 3.338a1.067 1.067 0 0 0 1.535 0l7.599-7.79a1.133 1.133 0 0 0-.014-1.559 1.067 1.067 0 0 0-1.521-.013z"
    />
  )
  const timelineArrow = (
    <path
      {...props}
      fillRule="nonzero"
      d="M.47 8.341c0-.218.076-.434.227-.611L6.957.447l1.429 1.222L2.65 8.341l5.735 6.672-1.43 1.222L.697 8.952a.934.934 0 0 1-.226-.61z"
    />
  )
  const mapIndicator = (
    <path
      {...props}
      fillRule="nonzero"
      d="M7 0C3.1 0 0 3.1 0 7c0 1.9.7 3.7 2.1 5 .1.1 4.1 3.7 4.2 3.8.4.3 1 .3 1.3 0 .1-.1 4.2-3.7 4.2-3.8 1.4-1.3 2.1-3.1 2.1-5 .1-3.9-3-7-6.9-7zm0 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    />
  )
  const gobackCourses = (
    <path
      {...props}
      fillRule="nonzero"
      d="M5.926 0L0 6l5.926 6L8 9.9 4.148 6 8 2.1z"
    />
  )
  const showWelcome = (
    <path
      {...props}
      fillRule="nonzero"
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H9v3H7V9H4V7h3V4h2v3h3v2z"
    />
  )
  const playVideo = (
    <g fill="none" fillRule="evenodd">
      <circle cx="11" cy="11" r="10" stroke={props.stroke} strokeWidth="2" />
      <path fill={props.fill} d="M9 15V7l6 4z" />
    </g>
  )
  const download = (
    <g {...props} fillRule="evenodd">
      <path d="M7 12c.3 0 .5-.1.7-.3L13.4 6 12 4.6l-4 4V0H6v8.6l-4-4L.6 6l5.7 5.7c.2.2.4.3.7.3zM0 14h14v2H0z" />
    </g>
  )

  const clock = (
    <path
      {...props}
      fillRule="nonzero"
      d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm4 9H7V4h2v3h3v2z"
    />
  )
  const closeModal = (
    <path
      {...props}
      fillRule="evenodd"
      d="M19 .171l-8 8-8-8L.171 3l8 8-8 8L3 21.829l8-8 8 8L21.829 19l-8-8 8-8z"
    />
  )
  const audio = (
    <path
      {...props}
      fillRule="nonzero"
      d="M8 0C3.589 0 0 3.589 0 8v5c0 1.654 1.346 3 3 3h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H2V8c0-3.309 2.691-6 6-6s6 2.691 6 6v1h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1c1.654 0 3-1.346 3-3V8c0-4.411-3.589-8-8-8z"
    />
  )
  const video = (
    <path
      {...props}
      fillRule="nonzero"
      d="M15 0H1C.4 0 0 .4 0 1v14c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zm-4.4 8.8l-4 3c-.6.5-1.6 0-1.6-.8V5a1 1 0 0 1 1.6-.8l4 3c.5.4.5 1.2 0 1.6z"
    />
  )
  const reading = (
    <g {...props} fillRule="nonzero">
      <path
        d="M5 7H1C0.4 7 0 6.6 0 6V2C0 1.4 0.4 1 1 1H5C5.6 1 6 1.4 6 2V6C6 6.6 5.6 7 5 7Z"
        fill="#B0CFE0"
      />
      <path d="M16 1H8V3H16V1Z" fill="#B0CFE0" />
      <path d="M16 5H8V7H16V5Z" fill="#B0CFE0" />
      <path d="M16 9H0V11H16V9Z" fill="#B0CFE0" />
      <path d="M16 13H0V15H16V13Z" fill="#B0CFE0" />
    </g>
  )
  const multimedia = (
    <g {...props} fillRule="nonzero">
      <path
        d="M4 7C5.65685 7 7 5.65685 7 4C7 2.34315 5.65685 1 4 1C2.34315 1 1 2.34315 1 4C1 5.65685 2.34315 7 4 7Z"
        fill="#B0CFE0"
      />
      <path
        d="M12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7Z"
        fill="#B0CFE0"
      />
      <path
        d="M4 15C5.65685 15 7 13.6569 7 12C7 10.3431 5.65685 9 4 9C2.34315 9 1 10.3431 1 12C1 13.6569 2.34315 15 4 15Z"
        fill="#B0CFE0"
      />
      <path
        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const questions = (
    <g {...props} fillRule="nonzero">
      <path d="M0 14h16v2H0zM11.7 3.3c.4-.4.4-1 0-1.4L10.1.3c-.4-.4-1-.4-1.4 0L0 9v3h3l8.7-8.7z" />
    </g>
  )
  const circularCheck = (
    <g {...props} fillRule="nonzero">
      <rect
        width="16"
        height="16"
        fill={UIVars.setColors.checkGreen}
        rx="8.5"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M7.125 10.531l5.385-5.385 1.097 1.097-6.364 6.364L3 8.364l.98-.98z"
      />
    </g>
  )
  const circularError = (
    <g {...props} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle id="Oval" fill="#CC0000" cx="8" cy="8" r="8"></circle>
      <g
        id="Group-66"
        transform="translate(8.000000, 8.000000) rotate(45.000000) translate(-8.000000, -8.000000) translate(3.000000, 3.000000)"
        fill="#FFFFFF">
        <rect id="Rectangle" x="4" y="0" width="2" height="10"></rect>
        <rect
          id="Rectangle-Copy-4"
          transform="translate(5.000000, 5.000000) rotate(90.000000) translate(-5.000000, -5.000000) "
          x="4"
          y="0"
          width="2"
          height="10"></rect>
      </g>
    </g>
  )
  const circularNeutral = (
    <g {...props} stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect
        id="Rectangle"
        fill={UIVars.setColors.icons}
        x="0"
        y="0"
        width="16"
        height="16"
        rx="8.5"></rect>
      <g
        id="Group"
        transform="translate(8.500000, 8.500000) rotate(-47.000000) translate(-8.500000, -8.500000) translate(5.000000, 5.000000)"
        stroke="#FFF"
        stroke-linecap="square"
        stroke-width="1.5">
        <line
          x1="0.963501331"
          y1="0.726786907"
          x2="6.09704098"
          y2="6.2318342"
          id="Line-17"></line>
      </g>
    </g>
  )
  const academicHistorial = (
    <g {...props} fillRule="nonzero">
      <path d="M0 0h4v4H0zM6 0h4v4H6zM12 0h4v4h-4zM0 6h4v4H0zM6 6h4v4H6zM12 6h4v4h-4zM0 12h4v4H0zM6 12h4v4H6zM12 12h4v4h-4z" />
    </g>
  )
  const menuListItems = (
    <g {...props} fillRule="nonzero">
      <path d="M6 1h10v2H6zM6 7h10v2H6zM6 13h10v2H6zM3 0H1C.4 0 0 .4 0 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM3 6H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM3 12H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z" />
    </g>
  )
  const arrowTopRight = (
    <g {...props} fillRule="nonzero">
      <path d="M6.793 2.793L.586 9 2 10.414l6.207-6.207L11 7V0H4z" />
    </g>
  )
  const bulletList = (
    <g {...props} fillRule="nonzero">
      <path d="M6 1h10v2H6zM6 7h10v2H6zM6 13h10v2H6zM3 0H1C.4 0 0 .4 0 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V1c0-.6-.4-1-1-1zM3 6H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1zM3 12H1c-.6 0-1 .4-1 1v2c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-2c0-.6-.4-1-1-1z" />
    </g>
  )
  const windowParagraph = (
    <g {...props} fillRule="nonzero">
      <path d="M5 6H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h4c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1zM8 0h8v2H8zM8 4h8v2H8zM0 8h16v2H0zM0 12h16v2H0z" />
    </g>
  )
  const materials = (
    <g {...props} fillRule="nonzero">
      <path d="M8 12.4L2.1 8.7 0 10l8 5 8-5-2.1-1.3z" />
      <path d="M0 5l8-5 8 5-8 5z" />
    </g>
  )
  const answers = (
    <g {...props} fill="#B0CFE0" fillRule="nonzero">
      <path
        {...props}
        d="M6.5 0C2.91 0 0 2.462 0 5.5c0 1.075.37 2.074 1 2.922V12l2.699-1.542A7.454 7.454 0 0 0 6.5 11c3.59 0 6.5-2.462 6.5-5.5S10.09 0 6.5 0z"
      />
      <path
        {...props}
        d="M16 9.5c0-.987-.429-1.897-1.147-2.639C14.124 10.348 10.66 13 6.5 13c-.103 0-.202-.018-.305-.021C7.231 13.617 8.556 14 10 14c.449 0 .886-.04 1.307-.11L15 16v-4h-.012C15.627 11.285 16 10.425 16 9.5z"
      />
    </g>
  )
  const search = (
    <g {...props} fill="#0189FF" fillRule="nonzero">
      <path d="M14.725 12.462l-2.537-2.538c.59-.984.937-2.132.937-3.361A6.57 6.57 0 0 0 6.562 0 6.57 6.57 0 0 0 0 6.563a6.57 6.57 0 0 0 6.563 6.562c1.23 0 2.377-.346 3.361-.938l2.538 2.538a.935.935 0 0 0 1.326 0l.937-.937a.936.936 0 0 0 0-1.326zM6.563 11.25a4.688 4.688 0 1 1 0-9.376 4.688 4.688 0 0 1 0 9.376z" />
    </g>
  )
  const refresh = (
    <g {...props} fill="#B0CFE0" fillRule="nonzero">
      <path d="M8.28 0l.747 6.4 2.24-2.1a4.79 4.79 0 0 1 0 7c-.96 1-2.347 1.5-3.734 1.5-1.386 0-2.773-.5-3.733-1.5a4.79 4.79 0 0 1 0-7c.64-.6 1.493-1.1 2.453-1.3l-.64-1.9C4.333 1.4 3.16 2 2.2 2.9c-2.88 2.7-2.88 7.1 0 9.9 1.387 1.3 3.307 2 5.227 2 2.026 0 3.84-.7 5.226-2 2.88-2.7 2.88-7.1 0-9.9L15 .7 8.28 0z" />
    </g>
  )
  const watch = (
    <g {...props} fill="#B0CFE0" fillRule="nonzero">
      <path d="M15.875.375c-.5-.5-1.25-.5-1.75 0s-.5 1.25 0 1.75l1 1L14 4.25A8.558 8.558 0 0 0 8.75 2.5 8.696 8.696 0 0 0 0 11.25 8.696 8.696 0 0 0 8.75 20a8.696 8.696 0 0 0 8.75-8.75c0-2-.625-3.75-1.75-5.25l1.125-1.125 1 1c.25.25.5.375.875.375s.625-.125.875-.375c.5-.5.5-1.25 0-1.75l-3.75-3.75zM8.75 17.5c-3.5 0-6.25-2.75-6.25-6.25S5.25 5 8.75 5 15 7.75 15 11.25s-2.75 6.25-6.25 6.25z" />
      <path d="M10 7.5H7.5v5h5V10H10z" />
    </g>
  )
  const questionnaire = (
    <g {...props} fill="#B0CFE0" fillRule="nonzero">
      <path d="M7.059 0H1.176C.526 0 0 .527 0 1.176V7.06c0 .65.527 1.176 1.176 1.176H7.06c.65 0 1.176-.526 1.176-1.176V1.176C8.235.526 7.71 0 7.06 0zM5.882 5.882h-3.53v-3.53h3.53v3.53zM17.647 10.588h-5.882c-.65 0-1.177.527-1.177 1.177v5.882c0 .65.527 1.177 1.177 1.177h5.882c.65 0 1.177-.527 1.177-1.177v-5.882c0-.65-.527-1.177-1.177-1.177zm-1.176 5.883h-3.53v-3.53h3.53v3.53zM7.059 10.588H1.176c-.65 0-1.176.527-1.176 1.177v5.882c0 .65.527 1.177 1.176 1.177H7.06c.65 0 1.176-.527 1.176-1.177v-5.882c0-.65-.526-1.177-1.176-1.177zm-1.177 5.883h-3.53v-3.53h3.53v3.53zM12.941 8.235h.065c.334-.018.645-.177.854-.439l4.706-5.882A1.178 1.178 0 0 0 16.728.441l-3.884 4.853-1.424-1.423a1.178 1.178 0 1 0-1.664 1.667L12.11 7.89c.221.22.52.344.832.344z" />
    </g>
  )
  const folio = (
    <g
      {...props}
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g id="I-G/-contenido" fill="#B0CFE0" fillRule="nonzero">
        <g id="Group">
          <rect id="Rectangle" x="0" y="0" width="2" height="16" />
          <rect id="Rectangle" x="14" y="0" width="2" height="16" />
          <rect id="Rectangle" x="3" y="0" width="2" height="11" />
          <rect id="Rectangle" x="11" y="0" width="2" height="11" />
          <polygon id="Path" points="10 11 6 11 6 0 10 0 10 0" />
        </g>
      </g>
    </g>
  )
  const info = (
    <g {...props} fill="none" fillRule="evenodd">
      <g id="c-info-(5)" fill="#B0CFE0" fillRule="nonzero">
        <path
          d="M8,0 C3.6,0 0,3.6 0,8 C0,12.4 3.6,16 8,16 C12.4,16 16,12.4 16,8 C16,3.6 12.4,0 8,0 Z M9,12 L7,12 L7,7 L9,7 L9,12 Z M8,6 C7.4,6 7,5.6 7,5 C7,4.4 7.4,4 8,4 C8.6,4 9,4.4 9,5 C9,5.6 8.6,6 8,6 Z"
          id="Shape"></path>
      </g>
    </g>
  )
  const stars = (
    <g {...props} fillRule="evenodd">
      <path
        d="M14.2499 5.4238L10.4734 4.87442L8.78761 1.45303C8.7075 1.31521 8.59262 1.20084 8.45446 1.12134C8.31629 1.04184 8.15968 1 8.00028 1C7.84087 1 7.68426 1.04184 7.5461 1.12134C7.40793 1.20084 7.29305 1.31521 7.21295 1.45303L5.52718 4.87529L1.75062 5.4238C1.5889 5.44699 1.4369 5.51501 1.31185 5.62015C1.1868 5.72529 1.09368 5.86334 1.04306 6.01868C0.992433 6.17401 0.986319 6.34042 1.02541 6.49905C1.06449 6.65768 1.14722 6.8022 1.26422 6.91623L3.99626 9.58003L3.35152 13.3417C3.32396 13.5026 3.34195 13.668 3.40347 13.8192C3.46499 13.9704 3.56758 14.1013 3.69964 14.1973C3.8317 14.2932 3.98796 14.3503 4.15076 14.362C4.31356 14.3738 4.4764 14.3397 4.62088 14.2638L8.00028 12.487L11.3779 14.262C11.5224 14.338 11.6852 14.372 11.848 14.3603C12.0108 14.3485 12.1671 14.2914 12.2992 14.1955C12.4312 14.0996 12.5338 13.9686 12.5953 13.8174C12.6569 13.6662 12.6748 13.5009 12.6473 13.34L12.0025 9.57828L14.7363 6.91623C14.853 6.80228 14.9356 6.65797 14.9746 6.49959C15.0136 6.34122 15.0076 6.17508 14.9572 6.01996C14.9068 5.86483 14.814 5.72688 14.6893 5.62169C14.5647 5.5165 14.4131 5.44826 14.2517 5.42467L14.2499 5.4238Z"
        fill="#F5A623"
      />
    </g>
  )
  const back = (
    <g {...props}>
      <g id="c-info-(5)" fillRule="nonzero">
        <path
          fillRule="evenodd"
          d="M0.000122411 8.39396C0.000122401 8.18414 0.0732025 7.97522 0.220275 7.80519L6.29502 0.787903L7.68262 1.96544L2.11669 8.39396L7.68262 14.8225L6.29502 16L0.220275 8.98273C0.0732025 8.8127 0.00012242 8.60378 0.000122411 8.39396Z"
        />
      </g>
    </g>
  )
  const arrowIn = (
    <g {...props}>
      <g id="c-info-(5)" fillRule="nonzero">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.38928 7.79113C8.38928 8.00606 8.3162 8.22006 8.16913 8.39423L2.09439 15.5823L0.706787 14.3761L6.27271 7.79113L0.706788 1.20618L2.09439 -7.56874e-06L8.16913 7.18804C8.3162 7.3622 8.38928 7.57621 8.38928 7.79113Z"
          fill="#60798E"
        />
      </g>
    </g>
  )
  const objectives = (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      {...props}
      d="M16 4L13 7L11 6.4L10 7.4C10.6 8.3 11 9.3 11 10.5C11 13.5 8.5 16 5.5 16C2.5 16 0 13.5 0 10.5C0 7.5 2.5 5 5.5 4.9C6.6 4.9 7.7 5.3 8.6 5.9L9.6 4.9L9 3L12 0L13 3L16 4ZM5.5 14C7.4 14 9 12.4 9 10.5C9 9.9 8.8 9.3 8.6 8.8L6.2 11.2C6 11.4 5.7 11.5 5.5 11.5C5.3 11.5 5 11.4 4.8 11.2C4.4 10.8 4.4 10.2 4.8 9.8L7.2 7.4C6.7 7.2 6.1 7 5.5 7C3.6 7 2 8.6 2 10.5C2 12.4 3.6 14 5.5 14Z"
    />
  )
  const bigStar = (
    <path
      {...props}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9635 16.5101C10.6732 16.3582 10.3268 16.3582 10.0365 16.5101L5.52664 18.8693C4.7939 19.2526 3.93904 18.6315 4.07716 17.8162L4.92727 12.7981C4.982 12.475 4.87497 12.1456 4.64079 11.9164L1.00346 8.35632C0.412481 7.77789 0.739008 6.77294 1.55711 6.65235L6.59233 5.91016C6.91651 5.86237 7.19671 5.6588 7.34234 5.36525L9.60417 0.805819C9.97167 0.0650204 11.0283 0.0650202 11.3958 0.805819L13.6577 5.36525C13.8033 5.6588 14.0835 5.86237 14.4077 5.91016L19.4429 6.65235C20.261 6.77294 20.5875 7.77789 19.9965 8.35632L16.3592 11.9164C16.125 12.1456 16.018 12.475 16.0727 12.7981L16.9228 17.8162C17.061 18.6315 16.2061 19.2526 15.4734 18.8693L10.9635 16.5101Z"
    />
  )
  const trash = (
    <path
      {...props}
      d="M16 4V2h-5V1c0-.552-.448-1-1-1H6c-.552 0-1 .448-1 1v1H0v2h16zM2 5v9c0 1.105.895 2 2 2h8c1.105 0 2-.895 2-2V5H2zm9.414 7.5L10 13.914l-2-2-2 2L4.586 12.5l2-2-2-2L6 7.086l2 2 2-2L11.414 8.5l-2 2 2 2z"
    />
  )
  const pdf = (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895508 0 0 0.895386 0 2V14C0 15.1046 0.895508 16 2 16H14C15.1045 16 16 15.1046 16 14V2C16 0.895386 15.1045 0 14 0H2ZM7.36426 2.82019C7.31299 2.83496 6.67285 3.61816 7.41406 4.28088C7.90771 3.32043 7.38672 2.81409 7.36426 2.82019ZM6.28955 10.1C6.81689 9.00159 7.30762 7.78821 7.67969 6.66431C8.26367 7.58093 8.96484 8.47034 9.6665 9.1825C8.55762 9.41003 7.37549 9.73169 6.28955 10.1ZM11.8335 9.84387C11.7588 9.78967 11.6714 9.7262 11.5635 9.65369C11.7603 9.63184 11.9507 9.61914 12.1265 9.61218C12.2627 9.60681 12.3906 9.60486 12.5054 9.60486C12.9346 9.60486 13.0391 9.65625 13.1025 9.68762L13.1162 9.69434C13.1089 9.71399 13.0947 9.74487 13.0664 9.78809C13.0493 9.8147 13.0264 9.84595 12.9966 9.8822C12.8364 10.0779 12.4893 10.0824 12.3682 10.0824C12.1611 10.0824 12.0513 10.0024 11.8335 9.84387ZM2.87744 12.9182C2.90967 12.6653 3.36279 12.217 4.47412 11.6719C3.63135 13.0308 3.1792 13.2108 3.10107 13.2325C2.85791 13.0701 2.87207 12.9602 2.87744 12.9182ZM2.58691 13.8519C2.73486 13.9487 2.90869 14 3.08984 14C3.54492 14 4.00439 13.6959 4.53613 13.0424C4.92432 12.566 5.34033 11.917 5.7749 11.1113C7.16748 10.5795 8.88965 10.0991 10.3647 9.82959C11.1855 10.5187 11.9214 10.8674 12.5542 10.8674C13.02 10.8674 13.4185 10.6805 13.708 10.3267C14.0093 9.95837 14.0781 9.62781 13.9111 9.34534C13.7104 9.00427 13.2163 8.83862 12.4028 8.83862C12.1738 8.83862 11.9199 8.85107 11.6431 8.87598C11.3413 8.90295 11.0122 8.94446 10.6567 9.00049C9.70508 8.11865 8.71289 6.83032 8.01221 5.56628C8.08643 5.29456 8.15576 5.02161 8.21729 4.74756C8.30127 4.37463 8.37402 3.99744 8.41016 3.61816C8.43213 3.38525 8.44092 3.14734 8.39453 2.91943C8.36279 2.76514 8.30615 2.6156 8.21143 2.47522C8.08545 2.28796 7.82324 2 7.55029 2C7.44043 2 7.14062 2.04333 7.02197 2.07739C6.85107 2.12732 6.7251 2.2146 6.62451 2.32922C6.54883 2.41541 6.4873 2.51709 6.43213 2.62988C6.06494 3.38086 6.56982 4.66077 7.08838 5.64746C6.64453 7.1886 5.90088 9.03345 5.11865 10.5306C3.14795 11.3195 2.10156 12.0939 2.00732 12.8328C1.97266 13.1018 2.0459 13.4966 2.58691 13.8519Z"
        fill="#B0CFE0"
      />
    </>
  )
  const whatsapp = (
    <path
      {...props}
      d="M13.6 2.3C12.1.8 10.2 0 8 0 3.7 0 .1 3.6.1 7.9c0 1.4.4 2.8 1.1 4L0 16l4.2-1.1c1.2.6 2.5 1 3.8 1 4.4 0 7.9-3.6 7.9-7.9.1-2.2-.8-4.2-2.3-5.7zm-1.7 8.5c-.2.5-1 .9-1.3.9-.3.1-1.3 0-2.4-.5-2-.9-3.3-2.9-3.4-3-.1-.1-.8-1.1-.8-2 0-.9.5-1.5.7-1.7.4-.4 1.2-.3 1.4.1.1.4.5 1.4.6 1.5.1.1.1.5-.2.7-.1 0-.6.4-.4.7.1.2.5.8 1.1 1.4.8.7 1.4.9 1.6 1 .2.1.3.1.4-.1.1-.1.5-.6.6-.8.1-.2.3-.2.4-.1.1.1 1.2.5 1.4.6.2.2.4.2.4.3.1.1.1.5-.1 1z"
    />
  )
  const contactMe = (
    <path
      {...props}
      d="M15 0H1C.448 0 0 .448 0 1v11c0 .552.448 1 1 1h3.586l2.707 2.707c.195.195.451.293.707.293.256 0 .512-.098.707-.293L11.414 13H15c.552 0 1-.448 1-1V1c0-.552-.448-1-1-1zM8 2c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zm-4 8s1-2 4-2 4 2 4 2H4z"
    />
  )
  const pin = (
    <path
      {...props}
      d="M7,0 C3.1,0 0,3.1 0,7 C0,8.9 0.7,10.7 2.1,12 C2.2,12.1 6.2,15.7 6.3,15.8 C6.7,16.1 7.3,16.1 7.6,15.8 C7.7,15.7 11.8,12.1 11.8,12 C13.2,10.7 13.9,8.9 13.9,7 C14,3.1 10.9,0 7,0 Z M7,9 C5.9,9 5,8.1 5,7 C5,5.9 5.9,5 7,5 C8.1,5 9,5.9 9,7 C9,8.1 8.1,9 7,9 Z"
    />
  )
  const assitant = (
    <g {...props}>
      <path
        d="M3 4C4.10457 4 5 3.10457 5 2C5 0.89543 4.10457 0 3 0C1.89543 0 1 0.89543 1 2C1 3.10457 1.89543 4 3 4Z"
        fill="#0189FF"
      />
      <path
        d="M9 7C9.26522 7 9.51957 6.89464 9.70711 6.70711C9.89464 6.51957 10 6.26522 10 6C10 5.73478 9.89464 5.48043 9.70711 5.29289C9.51957 5.10536 9.26522 5 9 5H2C1.46957 5 0.960859 5.21071 0.585786 5.58579C0.210714 5.96086 0 6.46957 0 7L0 15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16C1.26522 16 1.51957 15.8946 1.70711 15.7071C1.89464 15.5196 2 15.2652 2 15V11H3V15C3 15.2652 3.10536 15.5196 3.29289 15.7071C3.48043 15.8946 3.73478 16 4 16C4.26522 16 4.51957 15.8946 4.70711 15.7071C4.89464 15.5196 5 15.2652 5 15V7H9Z"
        fill="#0189FF"
      />
      <path
        d="M15 1H7V3H14V10H7V12H10.382L12.105 15.447C12.2236 15.6844 12.4315 15.8649 12.6832 15.9489C12.9349 16.033 13.2096 16.0136 13.447 15.895C13.6844 15.7764 13.8649 15.5685 13.9489 15.3168C14.033 15.0651 14.0136 14.7904 13.895 14.553L12.618 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11V2C16 1.73478 15.8946 1.48043 15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1Z"
        fill="#0189FF"
      />
    </g>
  )
  const anchorComment = (
    <g {...props}>
      <path
        d="M9 4.98765L7.58 6.40414L11.17 9.9753H2V0H0V11.9704H11.17L7.58 15.5415L9 16.958L15 10.9728L9 4.98765Z"
        fill="#C6C6C6"
      />
    </g>
  )
  const earlyMorning = (
    <path
      {...props}
      d="M14.7 9C15.4 8.2 15.9 7.1 16 6C12.6 6.3 9.8 3.5 10 0C7.7 0.2 5.8 1.8 5.2 4C2.3 4.4 0 7 0 10C0 13.3 2.7 16 6 16H12C14.2 16 16 14.2 16 12C16 10.8 15.5 9.8 14.7 9ZM12 14H6C3.8 14 2 12.2 2 10C2 7.8 3.8 6 6 6C9.1 6 9.8 8.4 10.1 10.6C13.1 9.4 14 10.8 14 12C14 13.1 13.1 14 12 14Z"
      fill="#B0CFE0"
    />
  )
  const morning = (
    <g {...props}>
      <path d="M9 0H7V2H9V0Z" fill="#B0CFE0" />
      <path
        d="M4.46458 3.12134L3.05078 1.70654L1.63598 3.12034L3.04978 4.53514L4.46458 3.12134Z"
        fill="#B0CFE0"
      />
      <path d="M2 7H0V9H2V7Z" fill="#B0CFE0" />
      <path
        d="M14.2942 3.05052L12.8794 1.63672L11.4656 3.05152L12.8804 4.46532L14.2942 3.05052Z"
        fill="#B0CFE0"
      />
      <path d="M16 7H14V9H16V7Z" fill="#B0CFE0" />
      <path
        d="M12.6 10C12.4 9.6 12.2 9.2 11.9 8.9C12 8.6 12 8.3 12 8C12 5.8 10.2 4 8 4C5.8 4 4 5.8 4 8C4 8.3 4 8.6 4.1 8.9C3.8 9.2 3.6 9.6 3.4 10C1.5 10 0 11.6 0 13.5C0 14.3 0.2 15 0.7 15.6L2.3 14.4C2.1 14.1 2 13.8 2 13.5C2 12.7 2.7 12 3.5 12C3.8 12 4.6 12.2 4.9 12.3L5.1 11.3C5.4 10 6.6 9 8 9C9.4 9 10.6 10 10.9 11.3L11.1 12.3C11.4 12.2 12.2 12 12.5 12C13.3 12 14 12.7 14 13.5C14 13.8 13.9 14.1 13.7 14.4L15.3 15.6C15.8 15 16 14.3 16 13.5C16 11.6 14.5 10 12.6 10Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const afternoon = (
    <g {...props}>
      <path d="M9 0H7V2H9V0Z" fill="#B0CFE0" />
      <path
        d="M14.2941 3.05152L12.8803 1.63672L11.4655 3.05052L12.8793 4.46532L14.2941 3.05152Z"
        fill="#B0CFE0"
      />
      <path d="M16 7H14V9H16V7Z" fill="#B0CFE0" />
      <path
        d="M11.5352 13.0193L12.95 14.4331L14.3638 13.0183L12.949 11.6045L11.5352 13.0193Z"
        fill="#B0CFE0"
      />
      <path d="M9 14H7V16H9V14Z" fill="#B0CFE0" />
      <path
        d="M1.56618 12.9485L2.97998 14.3633L4.39478 12.9495L2.98098 11.5347L1.56618 12.9485Z"
        fill="#B0CFE0"
      />
      <path d="M2 7H0V9H2V7Z" fill="#B0CFE0" />
      <path
        d="M4.46464 3.12034L3.04984 1.70654L1.63604 3.12134L3.05084 4.53514L4.46464 3.12034Z"
        fill="#B0CFE0"
      />
      <path
        d="M8 4C5.8 4 4 5.8 4 8C4 10.2 5.8 12 8 12C10.2 12 12 10.2 12 8C12 5.8 10.2 4 8 4Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const night = (
    <g {...props}>
      <path
        d="M13.9 10.6001C11.9 11.1001 9.8 10.4001 8.3 9.00006C6.3 7.00006 5.9 3.90006 7.4 1.50006C7.9 0.800065 7.2 -0.199935 6.3 6.50231e-05C4.8 0.300065 3.4 1.10007 2.3 2.20007C0.8 3.70007 0 5.80007 0 7.90006C0 10.0001 0.8 12.1001 2.4 13.6001C3.9 15.2001 5.9 16.0001 8.1 16.0001C10.3 16.0001 12.3 15.2001 13.8 13.6001C14.2 13.2001 14.6 12.7001 15 12.1001C15.4 11.4001 14.8 10.4001 13.9 10.6001Z"
        fill="#B0CFE0"
      />
      <path
        d="M15.7 3.7C16.1 3.3 16.1 2.7 15.7 2.3C15.3 1.9 14.7 1.9 14.3 2.3C14 2.6 13 2.6 12.7 2.3C12.3 1.9 11.7 1.9 11.3 2.3C10.9 2.7 10.9 3.3 11.3 3.7C11.6 4 11.6 5 11.3 5.3C10.9 5.7 10.9 6.3 11.3 6.7C11.7 7.1 12.3 7.1 12.7 6.7C13 6.4 14 6.4 14.3 6.7C14.7 7.1 15.3 7.1 15.7 6.7C16.1 6.3 16.1 5.7 15.7 5.3C15.4 5 15.4 4 15.7 3.7Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const board = (
    <g {...props}>
      <path
        d="M2 8H14C14.6 8 15 7.6 15 7V1C15 0.4 14.6 0 14 0H2C1.4 0 1 0.4 1 1V7C1 7.6 1.4 8 2 8Z"
        fill="#0189FF"
      />
      <path
        d="M16 10H0V12H4L2.2 14.4C1.9 14.8 2 15.5 2.4 15.8C2.6 15.9 2.8 16 3 16C3.3 16 3.6 15.9 3.8 15.6L6.5 12H7V14H9V12H9.5L12.2 15.6C12.4 15.9 12.7 16 13 16C13.2 16 13.4 15.9 13.6 15.8C14 15.5 14.1 14.8 13.8 14.4L12 12H16V10Z"
        fill="#0189FF"
      />
    </g>
  )
  const settings = (
    <g {...props}>
      <path
        d="M13.3 5.2L14.4 3.1L13 1.7L10.9 2.8C10.6 2.6 10.2 2.5 9.8 2.4L9 0H7L6.2 2.3C5.9 2.4 5.5 2.5 5.2 2.7L3.1 1.6L1.6 3.1L2.7 5.2C2.5 5.5 2.4 5.9 2.3 6.2L0 7V9L2.3 9.8C2.4 10.2 2.6 10.5 2.7 10.9L1.6 13L3 14.4L5.1 13.3C5.4 13.5 5.8 13.6 6.2 13.7L7 16H9L9.8 13.7C10.2 13.6 10.5 13.4 10.9 13.3L13 14.4L14.4 13L13.3 10.9C13.5 10.6 13.6 10.2 13.7 9.8L16 9V7L13.7 6.2C13.6 5.9 13.5 5.5 13.3 5.2ZM8 11C6.3 11 5 9.7 5 8C5 6.3 6.3 5 8 5C9.7 5 11 6.3 11 8C11 9.7 9.7 11 8 11Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const mobileChat = (
    <g {...props}>
      <path
        d="M8 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V5C16 5.26522 15.8946 5.51957 15.7071 5.70711C15.5196 5.89464 15.2652 6 15 6H10L7 8V1C7 0.734784 7.10536 0.48043 7.29289 0.292893C7.48043 0.105357 7.73478 0 8 0V0Z"
        fill="#B0CFE0"
      />
      <path
        d="M10 7V13H3V4H6V1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H10C10.5304 16 11.0391 15.7893 11.4142 15.4142C11.7893 15.0391 12 14.5304 12 14V7H10Z"
        fill="#B0CFE0"
      />
    </g>
  )
  const stopWatch = (
    <g {...props}>
      <path
        d="M12.7 0.3C12.3 -0.1 11.7 -0.1 11.3 0.3C10.9 0.7 10.9 1.3 11.3 1.7L12.1 2.5L11.2 3.4C10 2.5 8.6 2 7 2C3.1 2 0 5.1 0 9C0 12.9 3.1 16 7 16C10.9 16 14 12.9 14 9C14 7.4 13.5 6 12.6 4.8L13.5 3.9L14.3 4.7C14.5 4.9 14.7 5 15 5C15.3 5 15.5 4.9 15.7 4.7C16.1 4.3 16.1 3.7 15.7 3.3L12.7 0.3ZM7 14C4.2 14 2 11.8 2 9C2 6.2 4.2 4 7 4C9.8 4 12 6.2 12 9C12 11.8 9.8 14 7 14Z"
        fill="#B0CFE0"
      />
      <path d="M8 6H6V10H10V8H8V6Z" fill="#B0CFE0" />
    </g>
  )
  const absent = (
    <path
      d="M10.7076 1.29297C10.52 1.1055 10.2657 1.00018 10.0006 1.00018C9.7354 1.00018 9.4811 1.1055 9.29357 1.29297L6.00057 4.58597L2.70757 1.29297C2.51897 1.11081 2.26636 1.01002 2.00417 1.0123C1.74197 1.01457 1.49116 1.11974 1.30575 1.30515C1.12034 1.49056 1.01517 1.74137 1.0129 2.00357C1.01062 2.26577 1.11141 2.51837 1.29357 2.70697L4.58657 5.99997L1.29357 9.29297C1.19806 9.38522 1.12188 9.49556 1.06947 9.61757C1.01706 9.73957 0.989473 9.87079 0.988319 10.0036C0.987165 10.1363 1.01247 10.268 1.06275 10.3909C1.11303 10.5138 1.18728 10.6255 1.28117 10.7194C1.37507 10.8133 1.48672 10.8875 1.60962 10.9378C1.73251 10.9881 1.86419 11.0134 1.99697 11.0122C2.12975 11.0111 2.26097 10.9835 2.38297 10.9311C2.50498 10.8787 2.61532 10.8025 2.70757 10.707L6.00057 7.41397L9.29357 10.707C9.48217 10.8891 9.73477 10.9899 9.99697 10.9876C10.2592 10.9854 10.51 10.8802 10.6954 10.6948C10.8808 10.5094 10.986 10.2586 10.9882 9.99637C10.9905 9.73417 10.8897 9.48157 10.7076 9.29297L7.41457 5.99997L10.7076 2.70697C10.895 2.51944 11.0004 2.26513 11.0004 1.99997C11.0004 1.73481 10.895 1.4805 10.7076 1.29297Z"
      fill="#CC0000"
    />
  )
  const attend = (
    <path
      d="M10.2924 1.29298L3.99943 7.58598L1.70643 5.29298C1.51783 5.11082 1.26523 5.01003 1.00303 5.01231C0.740833 5.01458 0.49002 5.11975 0.304612 5.30516C0.119204 5.49057 0.014035 5.74138 0.0117566 6.00358C0.00947813 6.26578 0.110273 6.51838 0.292431 6.70698L3.29243 9.70698C3.47996 9.89445 3.73427 9.99977 3.99943 9.99977C4.2646 9.99977 4.5189 9.89445 4.70643 9.70698L11.7064 2.70698C11.8886 2.51838 11.9894 2.26578 11.9871 2.00358C11.9848 1.74138 11.8797 1.49057 11.6942 1.30516C11.5088 1.11975 11.258 1.01458 10.9958 1.01231C10.7336 1.01003 10.481 1.11082 10.2924 1.29298Z"
      fill="#28A745"
    />
  )
  const unlocked = (
    <g {...props}>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g id="unlock">
          <rect id="Rectangle" x="0" y="0" width="16" height="16"></rect>
          <g
            id="unlocked-copy"
            transform="translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) translate(1.000000, 0.000000)"
            fill="#B0CFE0"
            fillRule="nonzero">
            <path
              d="M10,1.3 C9.2,0.5 8.1,0 7,0 C4.8,0 3,1.8 3,4 L3,5 L1,5 C0.4,5 0,5.4 0,6 L0,15 C0,15.6 0.4,16 1,16 L13,16 C13.6,16 14,15.6 14,15 L14,6 C14,5.4 13.6,5 13,5 L11,5 L5,5 L5,4 C5,2.9 5.9,2 7,2 C7.6,2 8.1,2.2 8.5,2.7 L10,1.3 Z M7,8 C8.1,8 9,8.9 9,10 C9,10.7 8.6,11.4 8,11.7 L8,13 L6,13 L6,11.7 C5.4,11.4 5,10.7 5,10 C5,8.9 5.9,8 7,8 Z"
              id="Shape"></path>
          </g>
        </g>
      </g>
    </g>
  )
  const courseIcon = (
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      {...props}>
      <g
        id="origen-pregunta-/-curso"
        transform="translate(0.000000, -1.000000)"
        fill="#B0CFE0"
        fillRule="nonzero">
        <g id="save-for-later" transform="translate(0.000000, 1.000000)">
          <path
            d="M8.1,0 L1,0 C0.44771525,0 0,0.44771525 0,1 L0,13 C0,13.5522847 0.44771525,14 1,14 L13,14 C13.5522847,14 14,13.5522847 14,13 L14,1 C14,0.44771525 13.5522847,7.68579428e-16 13,0 L8.1,0 L8.1,0 Z M12,12 L2,12 L2,9 L12,9 L12,12 Z"
            id="Shape"></path>
        </g>
      </g>
    </g>
  )

  const coordinator = (
    <g fill="#0189FF">
      <path d="M9 14H8V1c0-.552-.448-1-1-1S6 .448 6 1v4H2L0 7l2 2h4v5H5c-.552 0-1 .448-1 1s.448 1 1 1h4c.552 0 1-.448 1-1s-.448-1-1-1zM14 1L10 1 10 5 14 5 16 3zM14 7L10 7 10 11 14 11 16 9z" />
    </g>
  )

  const arrowNavTest = (
    <path
      {...props}
      d="M21.926 14L16 20 21.926 26 24 23.9 20.148 20 24 16.1z"
      transform="translate(-477 -2969) translate(461 2955) rotate(-180 20 20) rotate(-180 20 20)"
    />
  )

  const presentation = (
    <>
      <path
        d="M3 4C4.10457 4 5 3.10457 5 2C5 0.89543 4.10457 0 3 0C1.89543 0 1 0.89543 1 2C1 3.10457 1.89543 4 3 4Z"
        fill="#B0CFE0"
      />
      <path
        d="M9 7C9.26522 7 9.51957 6.89464 9.70711 6.70711C9.89464 6.51957 10 6.26522 10 6C10 5.73478 9.89464 5.48043 9.70711 5.29289C9.51957 5.10536 9.26522 5 9 5H2C1.46957 5 0.960859 5.21071 0.585786 5.58579C0.210714 5.96086 0 6.46957 0 7L0 15C0 15.2652 0.105357 15.5196 0.292893 15.7071C0.48043 15.8946 0.734784 16 1 16C1.26522 16 1.51957 15.8946 1.70711 15.7071C1.89464 15.5196 2 15.2652 2 15V11H3V15C3 15.2652 3.10536 15.5196 3.29289 15.7071C3.48043 15.8946 3.73478 16 4 16C4.26522 16 4.51957 15.8946 4.70711 15.7071C4.89464 15.5196 5 15.2652 5 15V7H9Z"
        fill="#B0CFE0"
      />
      <path
        d="M15 1H7V3H14V10H7V12H10.382L12.105 15.447C12.2236 15.6844 12.4315 15.8649 12.6832 15.9489C12.9349 16.033 13.2096 16.0136 13.447 15.895C13.6844 15.7764 13.8649 15.5685 13.9489 15.3168C14.033 15.0651 14.0136 14.7904 13.895 14.553L12.618 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11V2C16 1.73478 15.8946 1.48043 15.7071 1.29289C15.5196 1.10536 15.2652 1 15 1Z"
        fill="#B0CFE0"
      />
    </>
  )

  const alarmDisable = (
    <>
      <path
        d="M10 14H6C6 14.5304 6.21071 15.0391 6.58579 15.4142C6.96086 15.7893 7.46957 16 8 16C8.53043 16 9.03914 15.7893 9.41421 15.4142C9.78929 15.0391 10 14.5304 10 14Z"
        fill="#B0CFE0"
      />
      <path
        d="M15.0994 12.98C15.3549 12.9572 15.5916 12.8363 15.7598 12.6428C15.9281 12.4492 16.0149 12.198 16.0019 11.9419C15.989 11.6858 15.8774 11.4446 15.6904 11.269C15.5035 11.0934 15.2559 10.997 14.9994 11H14.4994C14.0491 10.6366 13.6822 10.1806 13.4234 9.66303C13.1646 9.14545 13.02 8.57831 12.9994 8.00001V5.00001C13.0028 3.95791 12.6794 2.94097 12.0747 2.09225C11.47 1.24353 10.6145 0.605755 9.62841 0.268639C8.64234 -0.0684758 7.5754 -0.0879597 6.57768 0.212929C5.57996 0.513817 4.70168 1.11993 4.06641 1.94601L15.0994 12.98Z"
        fill="#B0CFE0"
      />
      <path
        d="M3 5.121V8C2.97941 8.57831 2.83483 9.14544 2.57604 9.66302C2.31725 10.1806 1.95029 10.6365 1.5 11H1C0.734784 11 0.48043 11.1054 0.292893 11.2929C0.105357 11.4804 0 11.7348 0 12C0 12.2652 0.105357 12.5196 0.292893 12.7071C0.48043 12.8946 0.734784 13 1 13H10.879L3 5.121Z"
        fill="#B0CFE0"
      />
      <path
        d="M15.0006 15.5C14.9349 15.5001 14.8698 15.4873 14.8091 15.4623C14.7484 15.4372 14.6932 15.4004 14.6466 15.354L0.646632 1.35402C0.552745 1.26013 0.5 1.1328 0.5 1.00002C0.5 0.867245 0.552745 0.739908 0.646632 0.646021C0.740518 0.552135 0.867856 0.49939 1.00063 0.49939C1.13341 0.49939 1.26074 0.552135 1.35463 0.646021L15.3546 14.646C15.4247 14.716 15.4725 14.8051 15.4919 14.9022C15.5112 14.9993 15.5013 15.1 15.4634 15.1915C15.4255 15.283 15.3613 15.3611 15.2789 15.416C15.1965 15.471 15.0997 15.5002 15.0006 15.5Z"
        fill="#B0CFE0"
      />
    </>
  )

  const remote = (
    <path
      d="M15 11V4C15 2.864 14.136 2 13 2H3C1.864 2 1 2.864 1 4V11H0V12C0 13.105 0.895 14 2 14H14C15.105 14 16 13.105 16 12V11H15ZM3 4H13V11H3V4Z"
      fill="#B0CFE0"
    />
  )

  /**
   * Construimos Map con los paths
   */
  const paths = new Map([
    ['absent', absent],
    ['academic_historial', academicHistorial],
    ['add', add],
    ['afternoon', afternoon],
    ['alert', alert],
    ['alarmDisable', alarmDisable],
    ['anchorComment', anchorComment],
    ['answers', answers],
    ['arrow', arrow],
    ['arrow-back', arrowBack],
    ['arrow-big', arrowBig],
    ['arrow-down', arrowDown],
    ['arrow-in', arrowIn],
    ['arrow-top-right', arrowTopRight],
    ['arrow-nav-test', arrowNavTest],
    ['assitant', assitant],
    ['attend', attend],
    ['audio', audio],
    ['back', back],
    ['bell', bell],
    ['belongs', belongs],
    ['bigStar', bigStar],
    ['blocked isTest', blockedIsTest],
    ['blocked pending isTest', blocked],
    ['blocked pending', blocked],
    ['blocked', blocked],
    ['board', board],
    ['bullet-list', bulletList],
    ['calendar', calendar],
    ['calendar-time', calendarTime],
    ['certificate', certificate],
    ['circle-check', circleCheck],
    ['circularCheck', circularCheck],
    ['circularError', circularError],
    ['circularNeutral', circularNeutral],
    ['clock', clock],
    ['close', close],
    ['close-modal', closeModal],
    ['comment', comment],
    ['completed', completed],
    ['contactMe', contactMe],
    ['coordinator', coordinator],
    ['courseIcon', courseIcon],
    ['done isTest', completed],
    ['done revised isTest', completed],
    ['done woRevised isTest', blockedIsTest],
    ['done', completed],
    ['download', download],
    ['earlyMorning', earlyMorning],
    ['estrellas', stars],
    ['filterNewOld', filterNewOld],
    ['flag', flag],
    ['folio', folio],
    ['goback-courses', gobackCourses],
    ['in-progress draft isTest', inProgress],
    ['in-progress isTest', inProgress],
    ['in-progress wAnswers isTest', inProgress],
    ['in-progress', inProgress],
    ['info', info],
    ['information-gmt', informationGmt],
    ['information-welcome', informationWelcome],
    ['justCheck', justCheck],
    ['letter', letter],
    ['lock', lock],
    ['lockWithHole', lockWithHole],
    ['map-indicator', mapIndicator],
    ['materials', materials],
    ['menuListItems', menuListItems],
    ['mobileChat', mobileChat],
    ['morning', morning],
    ['multimedia', multimedia],
    ['night', night],
    ['objectives', objectives],
    ['goals', objectives],
    ['opened isTest', opened],
    ['opened woDraft isTest', opened],
    ['opened', opened],
    ['pdf', pdf],
    ['phone', phone],
    ['pin', pin],
    ['play-video', playVideo],
    ['portafolio', portafolio],
    ['profile-icon', profileIcon],
    ['presentation', presentation],
    ['questionnaire', questionnaire],
    ['questions', questions],
    ['reading', reading],
    ['refresh', refresh],
    ['remote', remote],
    ['repetition', refresh],
    ['resources', materials],
    ['search', search],
    ['settings', settings],
    ['show-welcome', showWelcome],
    ['stars', stars],
    ['stopWatch', stopWatch],
    ['tilted-pen', tiltedPen],
    ['time', clock],
    ['timelineArrow', timelineArrow],
    ['trash', trash],
    ['trashNoX', trashNoX],
    ['unlocked', unlocked],
    ['video', video],
    ['watch', watch],
    ['whatsapp', whatsapp],
    ['window-paragraph', windowParagraph]
  ])

  /**
   * Retornamos el Path que buscamos por "name", si no está definido devolvemos un por defecto <path />
   */
  return paths.has(name) ? paths.get(name) : <path />
}

export default getPath
